import { AnnouncementForm } from '../../../AnnouncementForm'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { FormValues } from '../../../AnnouncementForm'
import Spinner from '@/common/components/Spinner'
import useMutationUpdateAnnouncement from '@/modules/announcement/api/hooks/useQueryUpdateAnnouncement'
import useQueryGetAnnouncementById from '@/modules/announcement/api/hooks/useQueryGetAnnouncementById'
import { AnnouncementQueryKeys } from '@/modules/announcement/keys'
import { useQueryClient } from '@tanstack/react-query'

export function EditAnnouncementForm() {
	const queryClient = useQueryClient()
	const { id } = useParams()
	const navigate = useNavigate()
	const { mutate: updateAnnouncement } = useMutationUpdateAnnouncement()
	const { data: announcement, isLoading } = useQueryGetAnnouncementById(id!)

	const onSubmit = (values: FormValues) => {
		if (!id) return

		updateAnnouncement(
			{ id, payload: values },
			{
				onSuccess: () => {
					toast.success('แก้ไขประกาศสำเร็จ')
					navigate('/operator/home-page')
					queryClient.invalidateQueries({
						queryKey: [AnnouncementQueryKeys.getAnnouncement],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	if (isLoading || !announcement) return <Spinner />
	return (
		<AnnouncementForm
			mode="edit"
			defaultValues={{
				title: announcement.title,
				content: announcement.content,
			}}
			onSubmit={onSubmit}
		/>
	)
}
